
import Vue from "vue";

export interface ChatBubbleProps {
  message: string;
}

export default Vue.extend({
  name: "ChatBubble",
  props: {
    message: {
      type: String,
      required: true,
    },
  },
});
